const TutorDetailsRate = ({ classBanner }) => {
  console.log('🚀 ~ TutorDetailsRate ~ classBanners:', classBanner)
  return (
    <div className="w-[200px] p-[20px] rounded-[10px] border-[1px] border-[#FFCA84] bg-[#FFF5EE] flex flex-col items-center justify-center">
      <img src="/assets/icon/big-star.svg" alt="Star" className="w-[100px] h-[100px]" />

      <span className="text-4xl text-primary-100 font-bold mt-[10px]">
        {/* TODO: make dynamic data */}
        {classBanner?.overall_rating}
      </span>
    </div>
  )
}

export default TutorDetailsRate
